var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('auth-state'),_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('auth-notice'),_c('login-history')],1),_c('b-col',{attrs:{"md":"4"}},[_c('auth-user-info')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }